export default "__VITE_ASSET__f871a057__"